import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import RecordMessage from './pages/RecordMessage';
import PodcastInterview from './pages/PodcastInterview';
import PodcastStudio from './pages/PodcastStudio';
import ComeAlive from './pages/ComeAlive';
import MessagesPortal from './pages/MessagesPortal';
import Messages from './pages/Messages';
import MessageCreate from './pages/MessageCreate';
import Recipients from './pages/Recipients';
import VoiceSetup from './pages/VoiceSetup';
import VoiceClone from './pages/VoiceClone';
import PodcastLibrary from './pages/PodcastLibrary';
import ConversationalPortal from './pages/ConversationalPortal';
import Pricing from './pages/Pricing';
import MilitaryLanding from './pages/MilitaryLanding';
import MilitaryDeployment from './pages/MilitaryDeployment';
import PrisonFamilies from './pages/PrisonFamilies';
import MessageScheduler from './pages/MessageScheduler';
import RecipientDetail from './pages/RecipientDetail';
import ContactUs from './pages/ContactUs';
import Navigation from './components/Navigation';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public portal routes (no navigation) */}
          <Route path="/portal/:token" element={<ConversationalPortal />} />
          <Route path="/messages-portal/:token" element={<MessagesPortal />} />
          
          {/* App routes with navigation */}
          <Route path="/*" element={
            <div className="min-h-screen bg-gray-50">
              <Navigation />
              <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <Routes>
                  {/* Public routes - anyone can view */}
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/contact" element={<ContactUs />} />
                  <Route path="/military-deployment" element={<MilitaryDeployment />} />
                  <Route path="/prison-families" element={<PrisonFamilies />} />
                  
                  {/* Protected routes - require authentication */}
                  <Route path="/record" element={<ProtectedRoute><RecordMessage /></ProtectedRoute>} />
                  <Route path="/podcast" element={<ProtectedRoute><PodcastStudio /></ProtectedRoute>} />
                  <Route path="/podcast-old" element={<ProtectedRoute><PodcastInterview /></ProtectedRoute>} />
                  <Route path="/come-alive" element={<ProtectedRoute><ComeAlive /></ProtectedRoute>} />
                  <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                  <Route path="/messages/create" element={<ProtectedRoute><MessageCreate /></ProtectedRoute>} />
                  <Route path="/recipients/:recipientId" element={<ProtectedRoute><RecipientDetail /></ProtectedRoute>} />
                  <Route path="/recipients" element={<ProtectedRoute><Recipients /></ProtectedRoute>} />
                  <Route path="/voice-setup" element={<ProtectedRoute><VoiceSetup /></ProtectedRoute>} />
                  <Route path="/voice-clone" element={<ProtectedRoute><VoiceClone /></ProtectedRoute>} />
                  <Route path="/podcast-library" element={<ProtectedRoute><PodcastLibrary /></ProtectedRoute>} />
                  <Route path="/schedule" element={<ProtectedRoute><MessageScheduler /></ProtectedRoute>} />
                </Routes>
              </main>
            </div>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
